import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-compliance-setup-guide',
  standalone: false,
  templateUrl: './admin-compliance-setup-guide.html',
  styleUrl: './admin-compliance-setup-guide.css',
})
export class AdminComplianceSetupGuide {
  steps = [
    {
      step: 1,
      title: 'Create Jurisdictions',
      description: 'Set up supported countries or global fallback jurisdictions. These are the foundation for tiers and policies.',
      route: '/admin/compliance/jurisdictions',
      button: 'Manage Jurisdictions'
    },
    {
      step: 2,
      title: 'Create Tiers',
      description: 'Define tier levels for each jurisdiction, including rank, default flag and customer type.',
      route: '/admin/compliance/tiers',
      button: 'Manage Tiers'
    },
    {
      step: 3,
      title: 'Configure Tier Limits',
      description: 'Set deposit, withdrawal and trade limits per currency for each tier. This controls allowed activity and thresholds.',
      route: '/admin/compliance/tiers',
      button: 'Open Tier Limits'
    },
    {
      step: 4,
      title: 'Create Policies',
      description: 'Create the KYC policy records that will drive the user verification experience for each tier and jurisdiction.',
      route: '/admin/compliance/policies',
      button: 'Manage Policies'
    },
    {
      step: 5,
      title: 'Add Policy Fields',
      description: 'Define the dynamic fields users must complete in the KYC wizard, such as name, date of birth, address and other inputs.',
      route: '/admin/compliance/policies',
      button: 'Manage Policy Fields'
    },
    {
      step: 6,
      title: 'Add Policy Documents',
      description: 'Define the documents users must upload, including file counts, expiry requirements, selfie match and supported MIME types.',
      route: '/admin/compliance/policies',
      button: 'Manage Policy Documents'
    },
    {
      step: 7,
      title: 'Add Policy Rules',
      description: 'Configure workflow, validation and compliance rules such as screening checks, manual review triggers and blocking rules.',
      route: '/admin/compliance/policies',
      button: 'Manage Policy Rules'
    }
  ];

  quickLinks = [
    {
      title: 'Jurisdictions',
      route: '/admin/compliance/jurisdictions'
    },
    {
      title: 'Tiers',
      route: '/admin/compliance/tiers'
    },
    {
      title: 'Policies',
      route: '/admin/compliance/policies'
    }
  ];
}
